import React, { useMemo, useState, createContext, useEffect } from 'react';

const DatePickerContext = createContext({});

export function DatePickerProvider({ children }) {
  const [date, setDate] = useState(new Date());
  const [toggle, setToggle] = useState(false);
  const [month, setMonth] = useState(+date.getMonth() + 1);
  const [year, setYear] = useState(date.getFullYear());
  const [decade, setDecade] = useState([]);
  const [decadeArr, setDecadeArr] = useState([]);
  const [displayDecades, setDisplayDecades] = useState(false);
  const months = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };
  const [currDateLabel, setCurrDateLabel] = useState(`${months[month]} ${year}`);

  useEffect(() => {
    setMonth(+date.getMonth() + 1);
    setYear(date.getFullYear());
  }, [date]);

  useEffect(() => {
    const handleDecade = () => {
      const yearStr = year.toString();
      const baseYear = yearStr.substring(0, yearStr.length - 1).concat(0);
      setDecade([+baseYear, +baseYear + 10]);
    };
    handleDecade();
  }, [year]);

  useEffect(() => {
    const handleDecadeArr = () => {
      const emptyArr = new Array(10);
      const filledArr = emptyArr.fill(1);
      const newDecadeArr = filledArr.map((_value, index) => +decade[0] + index);
      setDecadeArr([
        +newDecadeArr[0] - 1,
        ...newDecadeArr,
        newDecadeArr[newDecadeArr.length - 1] + 1,
      ]);
    };
    handleDecadeArr();
  }, [decade, year]);

  useEffect(() => setCurrDateLabel(`${months[month]} ${year}`), [month, year]);

  const memo = {
    toggle,
    month,
    year,
    months,
    setToggle,
    setMonth,
    setYear,
    displayDecades,
    setDisplayDecades,
    decade,
    setDecade,
    decadeArr,
    currDateLabel,
    setCurrDateLabel,
    date,
    setDate,
  };

  const value = useMemo(() => memo, [memo]);

  return <DatePickerContext.Provider value={value}>{children}</DatePickerContext.Provider>;
}

export default DatePickerContext;
